import React from "react";
import { Container, Row, Col, Alert, Button } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import UserDetails from "../components/user-profile-lite/UserDetails";
import DeveloperDetails from "../components/user-profile-lite/DeveloperDetails";
import Disclaimer from "../components/user-profile-lite/Disclaimer";

const Developer = () => (
  <div>
  
  <Container fluid className="main-content-container px-4">
  
    <Row noGutters className="page-header py-4">
      <PageTitle title="Developer" subtitle="Vinit Shahdeo" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <Row>
      <Col lg="4">
        <UserDetails />
      </Col>
      <Col lg="8">
        <DeveloperDetails />
      </Col>
    </Row>
    <Row>
      <Col lg="12">
      <Disclaimer/>
      </Col>
    </Row>
    
    
    
  </Container>
  <Alert className="mb-0" theme="light">
        <span className="text-secondary text-semibold">Hello there! Consider leaving a star on GitHub <a href="https://github.com/vinitshahdeo/COVID19" target="_blank">here</a>. Follow me on GitHub (<a href="https://github.com/vinitshahdeo/" target="_blank">@vinitshahdeo</a>). Stay Indoors, Stay Safe!</span>
      </Alert>
      
  </div>
);

export default Developer;
